import { getCustomFieldViewSections } from "@/components/custom-field/custom-field-view-sections.ts";
import { CustomFieldViewSections } from "@/components/custom-field/CustomFieldViewSections.tsx";
import useCustomFieldsWithEmployees from "@/hooks/use-custom-fields-with-employees.hook.ts";
import useOfferCustomFieldsHook from "@/hooks/use-offer-custom-fields.hook.tsx";
import { getOfferFormSections } from "@/pages/recruit/offers/offer-edit-fields.ts";
import { useEntityFormConfig } from "@/queries/use-custom-fields.query.ts";
import { ApiCFEntityTypes } from "@/types/custom-field.types.ts";
import { ApiOffer } from "@/types/recruit/offer.types.ts";

export const OfferViewFields = ({ offer }: { offer: ApiOffer }) => {
  const config = useEntityFormConfig(ApiCFEntityTypes.offer);
  const { renderOfferFieldListItem } = useOfferCustomFieldsHook();
  const offerWithEmployees: ApiOffer = {
    ...offer,
    custom_fields: useCustomFieldsWithEmployees(offer.custom_fields ?? []),
  };

  const sections = getCustomFieldViewSections(getOfferFormSections(config.sections), (field) =>
    renderOfferFieldListItem(field, offerWithEmployees)
  );

  return <CustomFieldViewSections sections={sections} isPending={config.isPending} paddingTop />;
};
